import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b8128db&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=3b8128db&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=3b8128db&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8128db",
  null
  
)

export default component.exports